import Style from './style';

function Loader() {
    const height = window.screen.height;
    return (
        <Style>
            <div
                id="loading"
                className="wh-100 d-flex flex-grow-1 align-items-center justify-content-center"
                style={{ height: height - 60 }}
            >
                <img src="/assets/icons/loading.gif" width="45px" alt="loaing " />
            </div>
        </Style>
    );
}

export default Loader;
